export default __webpack_public_path__ + "static/media/032-gun.bbb73565.png";